import { render, staticRenderFns } from "./RightDroneDetails.vue?vue&type=template&id=6a8f0fc3&scoped=true&"
import script from "./RightDroneDetails.vue?vue&type=script&lang=ts&"
export * from "./RightDroneDetails.vue?vue&type=script&lang=ts&"
import style0 from "./RightDroneDetails.vue?vue&type=style&index=0&id=6a8f0fc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f0fc3",
  null
  
)

export default component.exports